import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingStatus = ({ progress }) => {
  const getStatusMessage = () => {
    if (progress < 30) return 'Preparing image...';
    if (progress < 60) return 'Analyzing receipt...';
    if (progress < 90) return 'Extracting transaction details...';
    return 'Finalizing results...';
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-medium p-6 border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-primary/10 rounded-lg animate-pulse">
          <Icon name="Loader2" className="w-5 h-5 text-primary animate-spin" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Processing Receipt</h3>
      </div>

      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">{getStatusMessage()}</span>
          <span className="text-sm font-semibold text-primary">{progress}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-primary/80 transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Processing Steps */}
      <div className="space-y-3">
        <div className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
          progress >= 20 ? 'bg-green-50 border border-green-200' : 'bg-muted/50 border border-border'
        }`}>
          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
            progress >= 20 ? 'bg-green-500' : 'bg-muted-foreground/30'
          }`}>
            {progress >= 20 ? (
              <Icon name="Check" className="w-4 h-4 text-white" />
            ) : (
              <span className="text-xs font-semibold text-white">1</span>
            )}
          </div>
          <span className={`text-sm font-medium ${
            progress >= 20 ? 'text-green-900' : 'text-muted-foreground'
          }`}>
            Image uploaded and validated
          </span>
        </div>

        <div className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
          progress >= 60 ? 'bg-green-50 border border-green-200' : 'bg-muted/50 border border-border'
        }`}>
          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
            progress >= 60 ? 'bg-green-500' : 'bg-muted-foreground/30'
          }`}>
            {progress >= 60 ? (
              <Icon name="Check" className="w-4 h-4 text-white" />
            ) : (
              <span className="text-xs font-semibold text-white">2</span>
            )}
          </div>
          <span className={`text-sm font-medium ${
            progress >= 60 ? 'text-green-900' : 'text-muted-foreground'
          }`}>
            OCR analysis in progress
          </span>
        </div>

        <div className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
          progress >= 100 ? 'bg-green-50 border border-green-200' : 'bg-muted/50 border border-border'
        }`}>
          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
            progress >= 100 ? 'bg-green-500' : 'bg-muted-foreground/30'
          }`}>
            {progress >= 100 ? (
              <Icon name="Check" className="w-4 h-4 text-white" />
            ) : (
              <span className="text-xs font-semibold text-white">3</span>
            )}
          </div>
          <span className={`text-sm font-medium ${
            progress >= 100 ? 'text-green-900' : 'text-muted-foreground'
          }`}>
            Transaction details extracted
          </span>
        </div>
      </div>

      <div className="mt-4 p-3 bg-muted/50 rounded-lg">
        <p className="text-xs text-muted-foreground text-center">
          Using Tesseract.js OCR for text recognition. Processing may take a few moments depending on image quality.
        </p>
      </div>
    </div>
  );
};

export default ProcessingStatus;